// src/pages/AdminCoupons.jsx
import React, { useState, useEffect } from 'react';
import CouponForm from '../components/admin/CouponForm';
import CouponTable from '../components/admin/CouponTable';
import AdminLayout from '../components/admin/AdminLayout';
import { Drawer, DrawerContent } from '../components/ui/drawer';
import { Button } from '../components/ui/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [editCoupon, setEditCoupon] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const API = process.env.REACT_APP_API_BASE;

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded?.usertype !== 'master') {
        navigate('/login');
      }
    } catch (err) {
      console.error('Invalid token', err);
      navigate('/login');
    }
  }, [navigate]);
  
  const fetchCoupons = async () => {
    try {
      const res = await fetch(`${API}/api/coupons?search=${encodeURIComponent(searchTerm)}`);
      const data = await res.json();
      setCoupons(data);
    } catch (err) {
      toast.error('Failed to fetch coupons');
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, [searchTerm]);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this coupon?')) return;
    try {
      const res = await fetch(`${API}/api/coupons/${id}`, { method: 'DELETE' });
      if (res.ok) {
        toast.success('Coupon deleted');
        fetchCoupons();
      } else {
        toast.error('Failed to delete coupon');
      }
    } catch {
      toast.error('Server error');
    }
  };

  const handleReloadAndClose = () => {
    fetchCoupons();
    setEditCoupon(null);
    setDrawerOpen(false);
    toast.success(editCoupon ? 'Coupon updated' : 'Coupon created');
  };

  return (
    <AdminLayout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">Manage Coupons</h1>
        <Button onClick={() => {
          setEditCoupon(null);
          setDrawerOpen(true);
        }}>Add Coupon</Button>
      </div>

      <input
        type="text"
        placeholder="Search coupons..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full mb-4 p-2 border rounded"
      />

      <Drawer open={drawerOpen} onOpenChange={setDrawerOpen}>
        <DrawerContent>
          <div className="p-4">
            <h2 className="text-xl font-semibold mb-4">{editCoupon ? 'Edit Coupon' : 'Add New Coupon'}</h2>
            <CouponForm
              editCoupon={editCoupon}
              onReload={handleReloadAndClose}
              onClose={() => {
                setEditCoupon(null);
                setDrawerOpen(false);
              }}
            />
          </div>
        </DrawerContent>
      </Drawer>

      <CouponTable
        coupons={coupons}
        onEdit={(coupon) => {
          setEditCoupon(coupon);
          setDrawerOpen(true);
        }}
        onDelete={handleDelete}
        onReload={fetchCoupons}
      />
    </AdminLayout>
  );
}